import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box } from "@mui/material";


const ShiftCountGroupMstEditDialog = (props) => {

    const { dialogOpen, onClose, onSubmit, shiftCountGroupItem } = props;


    const [open, setOpen] = useState(dialogOpen);

    const [shiftCountGroupCd, setShiftCountGroupCd] = useState(shiftCountGroupItem?.shift_count_group_cd || "");
    const [shiftCountGroupName, setShiftCountGroupName] = useState(shiftCountGroupItem?.shift_count_group_name || "");
    const [shiftCountGroupDescription, setShiftCountGroupDescription] = useState(shiftCountGroupItem?.note || "");

    useEffect(() => {
        setShiftCountGroupCd(shiftCountGroupItem?.shift_count_group_cd || "");
        setShiftCountGroupName(shiftCountGroupItem?.shift_count_group_name || "");
        setShiftCountGroupDescription(shiftCountGroupItem?.note || "");
        setOpen(dialogOpen);
    }, [dialogOpen]);


    const handleClose = () => {
        setOpen(false);
        onClose();
    }
    const handleSubmit = () => {
        onSubmit(shiftCountGroupCd, shiftCountGroupName, shiftCountGroupDescription);
    }


    const styles = {
        dialogContent:{
            padding: "10px",
        },
        textField:{
            margin: "10px 0",
        }
    }
    return (
        <Dialog open={open} onClose={handleClose}>
                <DialogTitle>シフトカウントグループマスタ編集</DialogTitle>
            <DialogContent sx={styles.dialogContent}>
                <TextField fullWidth sx={styles.textField} label="コード" value={shiftCountGroupCd} onChange={(e)=>setShiftCountGroupCd(e.target.value)}/>
                <TextField fullWidth sx={styles.textField} label="名前" value={shiftCountGroupName} onChange={(e)=>setShiftCountGroupName(e.target.value)}/>
                <TextField fullWidth sx={styles.textField} label="説明" value={shiftCountGroupDescription} onChange={(e)=>setShiftCountGroupDescription(e.target.value)}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>キャンセル</Button>
                <Button disabled={shiftCountGroupCd === "" || shiftCountGroupName === ""} onClick={handleSubmit}>登録</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ShiftCountGroupMstEditDialog;

